/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verified_Knowledge_RagInputs */

const en_verified_knowledge_rag = /** @type {(inputs: Verified_Knowledge_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified Knowledge (RAG)`)
};

const es_verified_knowledge_rag = /** @type {(inputs: Verified_Knowledge_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conocimiento verificado (RAG)`)
};

const fr_verified_knowledge_rag = /** @type {(inputs: Verified_Knowledge_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connaissances vérifiées (RAG)`)
};

const de_verified_knowledge_rag = /** @type {(inputs: Verified_Knowledge_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiziertes Wissen (RAG)`)
};

const ja_verified_knowledge_rag = /** @type {(inputs: Verified_Knowledge_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検証済みのナレッジ (RAG)`)
};

const zh_verified_knowledge_rag = /** @type {(inputs: Verified_Knowledge_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已验证知识库 (RAG)`)
};

const ar_verified_knowledge_rag = /** @type {(inputs: Verified_Knowledge_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المعرفة الموثقة (RAG)`)
};

const id_verified_knowledge_rag = /** @type {(inputs: Verified_Knowledge_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengetahuan Terverifikasi (RAG)`)
};

const it_verified_knowledge_rag = /** @type {(inputs: Verified_Knowledge_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conoscenza Verificata (RAG)`)
};

const ru_verified_knowledge_rag = /** @type {(inputs: Verified_Knowledge_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверенные знания (RAG)`)
};

const pt_verified_knowledge_rag = /** @type {(inputs: Verified_Knowledge_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conhecimento Verificado (RAG)`)
};

const ko_verified_knowledge_rag = /** @type {(inputs: Verified_Knowledge_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검증된 지식 (RAG)`)
};

/**
* | output |
* | --- |
* | "Verified Knowledge (RAG)" |
*
* @param {Verified_Knowledge_RagInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verified_knowledge_rag = /** @type {((inputs?: Verified_Knowledge_RagInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verified_Knowledge_RagInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verified_knowledge_rag(inputs)
	if (locale === "es") return es_verified_knowledge_rag(inputs)
	if (locale === "fr") return fr_verified_knowledge_rag(inputs)
	if (locale === "de") return de_verified_knowledge_rag(inputs)
	if (locale === "ja") return ja_verified_knowledge_rag(inputs)
	if (locale === "zh") return zh_verified_knowledge_rag(inputs)
	if (locale === "ar") return ar_verified_knowledge_rag(inputs)
	if (locale === "id") return id_verified_knowledge_rag(inputs)
	if (locale === "it") return it_verified_knowledge_rag(inputs)
	if (locale === "ru") return ru_verified_knowledge_rag(inputs)
	if (locale === "pt") return pt_verified_knowledge_rag(inputs)
	return ko_verified_knowledge_rag(inputs)
});